import { render, staticRenderFns } from "./ReturnInfo.vue?vue&type=template&id=3fa6f0a0&scoped=true&"
import script from "./ReturnInfo.vue?vue&type=script&lang=js&"
export * from "./ReturnInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReturnInfo.vue?vue&type=style&index=0&id=3fa6f0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6f0a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/jamievetrovsky/Documents/WorkDevelopment/product-return-portal-fe/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VDataTable,VDivider,VFlex,VLayout})
